import { FlexColumn } from 'src/components/flex-containers'
import { Shapes } from 'src/components/theme'
import { AcquisitionHistory } from 'src/v2/views/owner-reveal/insights/acquisition-history/activity-feed'

export const AcquisitionHistoryContent = () => {
  return (
    <FlexColumn gap={Shapes.spacing[6]}>
      <AcquisitionHistory />
    </FlexColumn>
  )
}
